<template>
  <div class="licevoischet__page">
    <div class="container-md">
      <h4 class="mt-4 modal_title">
        {{$t("Перевод баллов партнёру")}}
        <span class="close_btn" v-on:click="$emit('close')"></span>
      </h4>
      <h5 class="m-0 p-0">{{currentUser.name}} <b-icon icon="arrow-right"></b-icon> {{selectedUser.fullname}} </h5>
      <div class="row transfert">
        <!-- <div class="col-md-6">
          <p>ЛО:</p>
          <p>{{ lo }} баллов</p>
        </div> -->
        <div class="col-md-6">
          <p>{{$t("Резерв")}}:</p>
          <p>{{ reserve | localInt}} {{$t("баллов")}}</p>
        </div>
      </div>
      <!-- <h3 class="perevod">
        {{$t("Перевод количества баллов")}}
      </h3> -->
      <div class="row edit end">
        <div class="col-md-6 mt-4">
          <span v-if="state" class="custom_label">
            {{$t("Партнер-получатель")}}
          </span>
          <el-autocomplete
            v-model="state"
            :fetch-suggestions="querySearchAsync"
            :placeholder="`${$t('Партнер-получатель')}`"
            clearable
            @clear="dd"
            @change="gg"
            @select="handleSelect"
          ></el-autocomplete>
        </div>
        <div class="col-md-6 mt-4 custom_input">
          <input type="text" name="sum" id="sum" required v-model="sum" step="0.1"
          v-currency="{
            currency: null,
            valueAsInteger: false,
            distractionFree: false,
            allowNegative: false
          }"
          @keydown="checkInput($event)"
          />
          <label for="sum">
            {{$t("Сумма")}}
          </label>
          <span class="clear_icon" @click="clearSum()"></span>
        </div>
      </div>
      <div class="row edit mt-4">
        <div class="col-md-6 custom_input comment">
          <input type="text" name="comm" id="comm" required v-model="comm" />
          <label for="comm">
            {{$t("Комментарий")}}
          </label>
          <span class="clear_icon" @click="clearComm()"></span>
        </div>
        <div class="col-md trans_btns">
          <button :disabled="!pointsGo" @click="send" :class="pointsGo ? '' : 'disabled'">
            {{$t("Подарить")}}
          </button>
        </div>
      </div>
    </div>
    <b-modal id="bv-modal-action" hide-footer centered  :hide-header-close="true" :no-close-on-backdrop="true">
      <div class="d-block text-center">
        <h3>
          {{$t('Операция выполняется')}}
        </h3>
        <p>{{$t("Пожалуйста подождите")}}...</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import $ from 'jquery';
// import Multiselect from 'vue-multiselect';
import backApi from '../assets/backApi';

export default {
  name: 'AgentInfoModalGiftPointsTransfert',
  // components: { Multiselect },
  props: ['lo', 'id', 'caller'],
  data() {
    return {
      state: '',
      comm: null,
      links: [],
      options: [],
      sum: null,
      reserve: null,
      toastCount: 0,
      loading: false,
      selectedUser: {
        name: '',
      },
      currentUser: {
        name: '',
      },
    };
  },
  async mounted() {
    backApi.get('/agent/transfer-info', {
      params: {
        another_agent_id: this.id,
      },
    }).then((response) => {
      console.log(response.data);
      this.reserve = response.data.reserve;
    });
    backApi.get('/agent/profile/child', {
      params: {
        another_agent_id: this.id,
      },
    }).then((response) => {
      console.log(response.data);
      this.currentUser = response.data;
    });
  },
  computed: {
    pointsGo() {
      if (
        this.state !== ''
        && this.state !== null
        && this.state !== ''
        && this.sum !== null
        && this.sum !== ''
      ) {
        return true;
        // eslint-disable-next-line no-else-return
      } else {
        return false;
      }
    },
  },
  clearSum() {
    this.sum = null;
  },
  methods: {
    // eslint-disable-next-line consistent-return
    checkInput(e) {
      // console.log(e.which);
      if (e.which === 189) {
        // eslint-disable-next-line no-restricted-globals
        e.preventDefault();
        return false;
      }
    },
    back() {
      const navEl = document.getElementsByClassName('router-link-exact-active router-link-active');
      $(navEl[0])
        .parent()
        .parent()
        .siblings()
        .addClass('active');
    },
    showToast(title, message, status) {
      // Use a shorter name for this.$createElement
      const h = this.$createElement;
      // Increment the toast count
      // Create the message
      const vNodesMsg = h('p', { class: ['text-center', 'mb-0'] }, [
        h('strong', { class: 'mr-2' }, message),
      ]);
      // Create the title
      const vNodesTitle = h(
        'div',
        { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
        [h('strong', { class: 'mr-2' }, title)],
      );
      // Pass the VNodes as an array for message and title
      this.$bvToast.toast([vNodesMsg], {
        title: [vNodesTitle],
        solid: true,
        variant: status,
      });
    },
    querySearchAsync(queryString, cb) {
      const qr = queryString === '' ? 'а' : queryString;
      backApi.get('/agent/transfert/distributors_new_system', { params: { find_str: qr } }).then((Response) => {
        Response.data.entries.forEach((u) => {
          // eslint-disable-next-line no-param-reassign
          u.value = `${u.id}-${u.name}-${u.stock_name}`;
        });
        // eslint-disable-next-line arrow-body-style
        const newMass = Response.data.entries;
        cb(newMass);
      });
    },
    handleSelect(item) {
      this.selectedUser = item;
    },
    gg() {
      console.log(this.selectedUser);
      if (this.selectedUser.name !== '') {
        this.state = `${this.selectedUser.id}-${this.selectedUser.name}`;
      } else {
        this.state = '';
      }
    },
    dd() {
      this.state = '';
      this.selectedUser = { name: '' };
    },
    makeToast(append = false) {
      // eslint-disable-next-line no-plusplus
      this.toastCount++;
      this.$bvToast.toast(`This is toast number ${this.toastCount}`, {
        title: 'BootstrapVue Toast',
        autoHideDelay: 5000,
        appendToast: append,
      });
    },
    async send() {
      const res = await this.createMessageBox(this.$t('Вы уверены что хотите подарить баллы ?'));
      if (res) {
        if (this.sum !== null && this.sum !== '') {
          if (Number(this.sum.replace(/,/g, '.').replace(/\s/g, '')) <= this.reserve) {
            this.$bvModal.show('bv-modal-action');
            await backApi
              .post('/agent/transfert-create', {
                agent_from: this.id,
                agent_to: this.selectedUser.id,
                amount: Number(this.sum.replace(/,/g, '.').replace(/\s/g, '')),
                comm: this.comm,
              })
              .then(() => {
                this.$bvModal.hide('bv-modal-action');
                this.$emit('enlarge-text', { to: this.selectedUser.id, from: this.id });
              })
              .catch((error) => {
                this.$bvModal.hide('bv-modal-action');
                this.showToast(this.$t('Дарение баллов'), error.response.data.detail, 'danger');
              });
          } else {
            this.$bvModal.hide('bv-modal-action');
            this.showToast(
              this.$t('Ошибка операции'),
              this.$t('Введeнная вами сумма превышает ваш резерв'),
              'danger',
            );
          }
          this.$bvModal.hide('bv-modal-action');
        }
        this.$bvModal.hide('bv-modal-action');
      }
    },
    createMessageBox(messageText) {
      const h = this.$createElement;
      // More complex structure
      const messageVNode = h('div', { class: ['foobar'] }, [h('h3', { class: ['text-center'] }, [messageText])]);
      // We must pass the generated VNodes as arrays
      return this.$bvModal.msgBoxConfirm([messageVNode], {
        buttonSize: 'md',
        centered: true,
        cancelTitle: 'Нет',
        okTitle: 'Да',
        size: 'xl',
      });
    },
  },
  watch: {
    // eslint-disable-next-line object-shorthand
    id: function () {
      if (this.id) {
        backApi.get('/agent/profile/child', {
          params: {
            another_agent_id: this.id,
          },
        }).then((response) => {
          console.log(response.data);
          this.currentUser = response.data;
        });
        backApi.get('/agent/transfer-info', {
          params: {
            another_agent_id: this.id,
          },
        }).then((response) => {
          console.log(response.data);
          this.reserve = response.data.reserve;
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.custom_input {
  // margin-top: 29px !important;
}
.close_btn {
  display: inline-block;
  position: absolute;
  right: 0;
}
div[role='combobox'] {
  width: 100%;
}
.transfert {
  margin-bottom: 0px;
  margin-top: 15px;
  & p {
    padding: 0;
    margin: 0;
  }
  & > .col-md-6 {
    p:nth-of-type(1) {
      color: #9a9a9a;
    }
    p:nth-of-type(2) {
      font-weight: 500;
    }
  }
}
.edit {
  & button {
    width: 100%;
    padding: 8px 0px;
    background: white;
    color: #32aaa7;
    border: 1px solid #32aaa7;
    border-radius: 2px;
    font-weight: 500;
  }
}
.trans_btns {
  // display: flex;
  // justify-content: space-between;
  & button {
    float: right;
  }
  & button.disabled {
    color: #9a9a9a;
    border-color: #c4c4c4;
    cursor: auto;
  }
}
@media (max-width: 768px) {
  .perevod {
    font-size: 20px;
    // text-transform: uppercase;
    margin-bottom: 0;
  }
  .comment {
    margin-bottom: 30px;
  }
}
@media (max-width: 425px) {
  .comment {
    margin-bottom: 30px;
  }
  .perevod {
    font-size: 16px;
    // text-transform: uppercase;
    margin-bottom: 0;
  }
  .trans_btns {
    flex-direction: column;
    button {
      width: 100%;
      margin-bottom: 20px;
      font-size: 16px;
    }
  }
  .transfert {
    & p {
      font-size: 14px;
    }
    & > .col-md-6 {
      p:nth-of-type(1) {
      }
      p:nth-of-type(2) {
      }
    }
  }
}
</style>
<style></style>
